<template>
  <div class="pratice-banner-content">
    <div
      class="pratice-banner-image"
      :style="{ backgroundImage: `url(${praticePageStoreBannerImageSrc})` }"
    ></div>
    <div class="pratice-overlay-image">
      <h1 class="pratice-banner-title">
        {{ praticePageStoreBannerImageTitle }}
      </h1>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PraticePageMixin from "@/mixins/pratice-page-mixin"
import { PraticePageStore } from '@/store/verbal-identity-page/pratice-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PraticeBannerSection extends Mixins(PraticePageMixin) {
  praticePageStore: PageStoreContract = getModule(PraticePageStore, this.$store)

  get praticePageStoreBannerImageTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get praticePageStoreBannerImageSrc(): string {
    return this.getElementMedia(0, 0)
  }

  async getPraticePageStore(): Promise<void> {
    await this.praticePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.praticePageStore.isLoading) {
      await this.getPraticePageStore()
    }
  }
}
</script>

<style lang="scss">
.pratice-banner-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: gray;
  max-height: 28rem;
  width: 100%;
  justify-items: center;
  justify-content: center;
}

.pratice-banner-image {
  position: relative;
  width: 100%;
  height: 451px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.pratice-overlay-image {
  position: absolute;
  bottom: 9rem;
  left: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 1;
  pointer-events: none;
  text-align: left;
}

.pratice-banner-title {
  font-size: 8rem; 
  margin: 0;
  font-weight: 400;
  letter-spacing: -0.01em;
  text-align: left;
}
</style>
